import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyServices = createAsyncThunk('/dashboard_detail_company_services/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyGoodsServiceDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyServicesSlice = createSlice({
    name: 'dashboard_detail_company_services',
    initialState: {
        isLoading: false,
        dashboard_detail_company_services: []
    },

    /*extraReducers: {
        [getDetailCompanyServices.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyServices.fulfilled]: (state, action) => {
            state.dashboard_detail_company_services = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyServices.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyServices.pending, (state) => {
                state.isLoading = true;
            })           
            .addCase(getDetailCompanyServices.fulfilled, (state, action) => {
                state.dashboard_detail_company_services = action.payload.data;
                state.isLoading = false;
            })           
            .addCase(getDetailCompanyServices.rejected, (state) => {
                state.isLoading = false;
            })   
    }
})

export default dashboardDetailCompanyServicesSlice.reducer